
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EditorModule } from '@tinymce/tinymce-angular';


import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AttachmentsModalComponent } from '../shared/components/attachments-modal/attachments-modal.component';
import { DiaryFormModalComponent } from '../shared/components/diary-form-modal/diary-form-modal.component';
import { ClientNotesModalComponent } from '../shared/components/client-notes-modal/client-notes-modal.component';
import { CaseNotesModalComponent } from '../shared/components/case-notes-modal/case-notes-modal.component';
import { SearchComponent } from '../shared/components/search/search.component';
import { FileUploaderComponent } from '../shared/components/file-uploader/file-uploader.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    EditorModule,
    SearchComponent,
    FileUploaderComponent
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    AttachmentsModalComponent,
    DiaryFormModalComponent,
    ClientNotesModalComponent,
    CaseNotesModalComponent
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    AttachmentsModalComponent,
    DiaryFormModalComponent,
    ClientNotesModalComponent,
    CaseNotesModalComponent,
    SearchComponent,
    FileUploaderComponent
  ]
})
export class ComponentsModule { }
